import { readableForeground } from '@features/tenant/contrast';

export const isPrimaryColor = (value: string) =>
  /^#(?:[\da-f]{3}|[\da-f]{6})$/i.test(value);

export function safeLogoUrl(value = ''): string {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password
      ? url.href
      : '';
  } catch {
    return '';
  }
}

export function primaryTokens(color: string) {
  if (!isPrimaryColor(color)) return null;
  const hex =
    color.length === 4
      ? color
          .slice(1)
          .split('')
          .map((digit) => digit + digit)
          .join('')
      : color.slice(1);
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;
  const lightness = (max + min) / 2;
  const saturation =
    delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));
  const hue =
    delta === 0
      ? 0
      : ((max === r
          ? (g - b) / delta
          : max === g
            ? (b - r) / delta + 2
            : (r - g) / delta + 4) *
          60 +
          360) %
        360;
  return {
    primary: `${String(Number(hue.toFixed(2)))} ${String(Number((saturation * 100).toFixed(2)))}% ${String(Number((lightness * 100).toFixed(2)))}%`,
    foreground: readableForeground([r, g, b]),
  };
}
